import React from "react";
import { Route } from "react-router-dom";
import { ProgramCard } from "./ProgramCard";
import { ProgramEditDialog } from "./program-edit-dialog/ProgramEditDialog";
import { ProgramUIProvider } from "./ProgramUIContext";
import { PrivateRoute } from "../../../../PrivateRoute";
import { RoleChecker } from "../../../../RoleChecker";

export function ProgramPage({ history }) {
  const programUIEvents = {
    newProgramButtonClick: () => {
      history.push("/program/new");
    },
    openEditProgramPage: (id) => {
      history.push(`/program/${id}/edit`);
    },
  };

  return (
    <ProgramUIProvider programUIEvents={programUIEvents}>

        <PrivateRoute role={RoleChecker('Create', 'program')} component={ProgramEditDialog}
            path="/program/new" />
        <PrivateRoute role={RoleChecker('Edit', 'program')} component={ProgramEditDialog}
            path="/program/:id/edit" />

        <Route path="/program/new">
            {({ history, match }) => (
                <ProgramEditDialog
                    show={match != null}
                    onHide={() => {
                        history.push('/program');
                    }}
                />
            )}
        </Route>

        <Route path="/program/:id/edit">
            {({ history, match }) => (
                <ProgramEditDialog
                    show={match != null}
                    id={match && match.params.id}
                    onHide={() => {
                        history.push('/program');
                    }}
                />
            )}
        </Route>

        <ProgramCard />
    </ProgramUIProvider>
    // <ProgramUIProvider programUIEvents={programUIEvents}>
    //   <PrivateRoute
    //     role={RoleChecker("Create", "program")}
    //     component={ProgramEditDialog}
    //     path="/program/new"
    //   />
    //   <PrivateRoute
    //     role={RoleChecker("Edit", "program")}
    //     component={ProgramEditDialog}
    //     path="/program/:id/edit"
    //   />

    //   <Route path="/program/new">
    //     {({ history, match }) => (
    //       <ProgramEditDialog
    //         show={match != null}
    //         onHide={() => {
    //           history.push("/program");
    //         }}
    //       />
    //     )}
    //   </Route>

    //   <Route path="/program/:id/edit">
    //     {({ history, match }) => (
    //       <ProgramEditDialog
    //         show={match != null}
    //         id={match && match.params.id}
    //         onHide={() => {
    //           history.push("/program");
    //         }}
    //       />
    //     )}
    //   </Route>

      // <ProgramCard />
    // </ProgramUIProvider>
  );
}
